import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataService {
  // Use Subject for one-time events
  private messageSubject = new Subject<string>();
  message$ = this.messageSubject.asObservable();

  // Use BehaviorSubject to maintain current state
  private dataSubject = new BehaviorSubject<string>('');
  data$ = this.dataSubject.asObservable();

  sendMessage(message: string) {
    this.messageSubject.next(message);
  }

  updateData(data: string) {
    this.dataSubject.next(data);
  }
}